/**
 * 电影（含子路由）
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/movie',
    component: () => import('@/views/movie/entry.vue'),
    children: [
      {
        path: '',
        name: 'movieIndex',
        redirect: '/movie/film',
        component: () =>
          import(
            /* webpackChunkName: "movieIndex" */
            '@/views/movie/index.vue'
          ),
        meta: {
          title: '电影'
        },
        children: [
          {
            path: '/movie/film',
            name: 'movie',
            component: resolve => require(['@/views/movie/film'], resolve),
            meta: {
              title: '电影首页',
              is_festivalPop: true
            }
          },
          {
            path: '/movie/cinema',
            name: 'cinema',
            component: resolve => require(['@/views/movie/cinema'], resolve),
            meta: {
              title: '电影院'
            }
          },
          {
            path: '/movie/audio_visual',
            name: 'audio_visual',
            component: resolve =>
              require(['@/views/movie/audio_visual'], resolve),
            meta: {
              title: '视听列表'
            }
          }
        ]
      },
      {
        path: '/movie/movie_detail',
        name: 'movie_detail',
        component: () =>
          import(
            /* webpackChunkName: "movieDymc" */
            '@/views/movie/movie_detail.vue'
          ),
        meta: {
          title: '电影详情',
          keepAlive: true
        }
      },
      {
        path: '/movie/cinema_detail',
        name: 'cinema_detail',
        component: () =>
          import(
            /* webpackChunkName: "movieYycq" */
            '@/views/movie/cinema_detail.vue'
          ),
        meta: {
          title: '电影院详情'
          // keepAlive: true
        }
      },
      {
        path: '/movie/cinema_searchResult',
        name: 'cinema_searchResult',
        component: () =>
          import(
            /* webpackChunkName: "movieYycq" */
            '@/views/movie/cinema_searchResult.vue'
          ),
        meta: {
          title: '影院搜索结果'
          // keepAlive: true
        }
      },
      {
        path: '/movie/virtual',
        name: 'virtual',
        component: () =>
          import(
            /* webpackChunkName: "movieYycq" */
            '@/views/movie/virtual.vue'
          ),
        meta: {
          title: '电影虚拟券'
        }
      },
      {
        path: '/movie/pay',
        name: 'moviePay',
        component: () =>
          import(
            /* webpackChunkName: "movieJiesuan" */
            '@/views/movie/pay.vue'
          ),
        meta: {
          title: '电影收银台'
        }
      },
      {
        path: '/movie/choose',
        name: 'xuanzuo',
        component: () =>
          import(
            /* webpackChunkName: "movieChoose" */
            '@/views/movie/choose.vue'
          ),
        meta: {
          title: '选座'
        }
      },
      {
        path: '/movie/checkTicket',
        name: 'checkTicket',
        component: () =>
          import(
            /* webpackChunkName: "movieCheck" */
            '@/views/movie/checkTicket.vue'
          ),
        meta: {
          title: '出票'
        }
      },
      {
        path: '/movie/exchangeResult',
        name: 'exchangeResult',
        component: () =>
          import(
            /* webpackChunkName: "movieExchange" */
            '@/views/movie/exchangeResult.vue'
          ),
        meta: {
          title: '兑换结果'
        }
      }
    ]
  }
];
